import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {Provider, Store} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import App from './components/app';
import Notification from './components/common/layout/notification/notification';

import registerServiceWorker from './registerServiceWorker';

import {container, TYPES} from './utils/inversify-config';
import './utils/container-bootstrap';
import MeepoState from './reduxstore/meepo-state';
import ScrollToTop from './theme/app/ScrollToTop';
import * as moment from 'moment';
import UserClient from './middleware/user-client';
import 'moment/locale/es';

const userService = container.get<UserClient>(TYPES.USER_SERVICE);
const store = container.get<Store<MeepoState>>(TYPES.REDUX_STORE);

setTimeout(() => {
    userService.autenticar();
}, 3000);

moment.locale('es');

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter basename='/'>
            <ScrollToTop>
                <Notification/>
                <App/>
            </ScrollToTop>
        </BrowserRouter>
    </Provider>,
    document.getElementById('meepo-client') as HTMLElement
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx